import { getCurrentLocalDate } from "helpers/CurrentDate/getCurrentLocalDate";

export interface ServiceQuotationFormValues {
  // Quotation Details
  quotation_id?: string; // For edit mode
  quotation_date: string;
  valid_until: string;
  enquiry_reference_number: string;
  enquiry_service_id?: string;
  uid_number?: string;
  reference_number?: string;
  initiated_by: string;

  // Quotation Status
  quotation_status?: string;
  quotation_stage?: string;

  // Currency (default INR)
  currency_name?: string;
  currency_code?: string;
  currency_symbol?: string;
  currency_rate_in_inr?: number;

  // Customer Details
  customer_details: any; // Complete customer information for backend
  company: {
    company_id: string;
    company_name: string;
    industry?: string;
    gst_type?: string;
    company_email?: string;
    phone_number?: string;
    gstin?: string;
    billing_address?: any;
    contacts?: any[];
    shipping_addresses?: any[];
  } | null;
  contact_persons: Array<{
    id: string;
    name: string;
  }>;

  // Agent Details
  agent_name: string;

  // Assign Members
  members: Array<{
    id: string;
    name: string;
    initials?: string;
  }>;
  assigned_technician?: any[];


  // Services
  services: Array<{
    id: string;
    sr_no: number;
    model: string;
    product: string; // Service name
    serial_no: string;
    service_category: string;
    service_method: string;
    service_type: string;
    execution_mode: string;
    product_quantity: number; // Always 1 for services
    service_amount: string;
    service_address: string;
    reported_complaint: string;
    accessories?: any[];
  }>;

  // Terms & Conditions
  terms_and_conditions: Array<{
    id: string;
    type: string;
    option: string;
    description: string;
  }>;

  // Notes, Tags & Attachments
  notes: string;
  tags: string[];
  attachments: File[];

  // Follow-up
  next_follow_up_date: string;
  follow_up_remarks: string;

  // Totals
  subtotal_before_discount: number;
  total_item_discounts: number;
  net_total: number;
  total_gst_value: number;
  grand_total_amount: number;
  bill_from_address?: any;
}

export const DEFAULT_ORGANISATION = {
  organization_id: "4f2e3a6c-5c4c-4445-92b6-6f64a26b1c78",
  organization_name: "MECORD SYSTEMS & SERVICES PVT. LTD.",
  org_address: "HILLVIEW INDUSTRIAL ESTATE, 304, off Lal Bahadur Shastri Marg, Amrut Nagar, Ghatkopar-W.",
  org_city: "Mumbai",
  org_state: "Maharashtra",
  org_country: "India",
  org_pincode: 400086
};

// Get default date (today) using getCurrentLocalDate helper
const defaultQuotationDate = getCurrentLocalDate();

export const initialServiceQuotationValues: ServiceQuotationFormValues = {
  quotation_date: defaultQuotationDate,
  valid_until: "",
  enquiry_reference_number: "",
  enquiry_service_id: "",
  uid_number: "",
  reference_number: "",
  initiated_by: "",
  customer_details: null,
  company: null,
  contact_persons: [],
  agent_name: "",
  members: [],
  assigned_technician: [],
  services: [],
  terms_and_conditions: [],
  notes: "",
  tags: [],
  attachments: [],
  next_follow_up_date: "",
  follow_up_remarks: "",
  subtotal_before_discount: 0,
  total_item_discounts: 0,
  net_total: 0,
  total_gst_value: 0,
  grand_total_amount: 0,
  bill_from_address: DEFAULT_ORGANISATION,
};





